import React from 'react';
import ReactDOM from 'react-dom';
import Ecards from "./Ecards";

window.addEventListener('DOMContentLoaded', () => {
    const wpBlockZp4Ecards = document.querySelectorAll('.wp-block-zp4-shop-ecards');
    if (wpBlockZp4Ecards.length) {
        wpBlockZp4Ecards.forEach(container => {
            const siteUrl = container.getAttribute('data-site-url');
            ReactDOM.hydrate(
                <Ecards siteUrl={siteUrl} />,
                container
            );
        });
    }
});
